var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.header }, [
    _c("div", { class: _vm.$style.headerContainer }, [
      _c(
        "div",
        { class: _vm.$style.headerLogo, on: { click: _vm.handleLogoClick } },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/img/horizontal.png"),
              alt: "Burger Boss"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.$style.headerLogoMobile,
          on: { click: _vm.handleLogoClick }
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/img/white.png"),
              alt: "Burger Boss"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.headerMenu },
        [
          _c("DesktopUserData"),
          _vm._v(" "),
          _c("DesktopRestaurantButton"),
          _vm._v(" "),
          _c("DesktopCartIcon")
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/desktop/components/DesktopHeader.vue?vue&type=template&id=17d5ecf7&
// module id = null
// module chunks = 